import { z } from "zod";

export const restockItemsForReturn = {
  input: z.object({
    returnId: z.string(),
    itemsToRestock: z.optional(z.record(z.boolean())),
  }),
  output: z.literal("SUCCESS"),
};
